import React from 'react';
import { motion } from 'framer-motion';
import Button from './ui/Button';

const TourSection = () => {
  return (
    <section className="py-24 bg-aged-ivory overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="lg:col-span-5 order-2 lg:order-1"
          >
            <h2 className="text-3xl md:text-4xl font-serif text-deep-charcoal mb-6">
              What to Expect During Your Private Tour
            </h2>
            <p className="text-lg text-deep-charcoal/80 font-light leading-relaxed mb-8">
              The true magic of Padua Weddings is best understood in person. A private tour typically takes about one hour, allowing you to immerse yourself in the atmosphere and visualize every chapter of your wedding day.
            </p>
            
            <ul className="space-y-4 mb-10">
              {[
                "Experience the breathtaking ceremony and reception spaces",
                "Walk the guest journey from arrival to final send-off",
                "Discuss your vision for a specific season or date",
                "Review guest count and event priorities in real-time",
                "Get expert insights on catering, coordination, and DJ services",
                "Receive a personalized starting estimate during your visit"
              ].map((item, i) => (
                <li key={i} className="flex items-start">
                  <span className="text-olive-grove mr-3 mt-1 text-xl">✓</span>
                  <span className="text-deep-charcoal/90 font-light">{item}</span>
                </li>
              ))}
            </ul>

            <div className="hidden lg:block">
              <Button href="https://tour.paduaweddings.com" variant="primary">
                Begin With a Private Tour
              </Button>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="lg:col-span-7 order-1 lg:order-2 relative"
          >
            <div className="aspect-[4/3] md:aspect-video lg:aspect-[4/3] rounded-2xl overflow-hidden shadow-editorial border border-warm-stone/40 group">
               <img 
                 src="https://images-pw.pixieset.com/elementfield/lypG6YV/0888-efca2a4c-1000.jpg" 
                 alt="Romantic ceremony aisle with floral arch at Padua Weddings"
                 loading="lazy"
                 className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
               />
               <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-olive-grove/10 rounded-full blur-2xl"></div>
            </div>
            
            <div className="mt-8 text-center">
              <p className="text-sm text-deep-charcoal/60 italic font-light leading-relaxed max-w-md mx-auto mb-8">
                During your private tour, you can walk the ceremony and reception spaces, understand the guest flow, and receive guidance on your starting estimate.
              </p>
              <div className="lg:hidden">
                <Button href="https://tour.paduaweddings.com" variant="primary" className="w-full sm:w-auto">
                  Schedule Your Private Tour
                </Button>
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default TourSection;